export function useDuplicateBookingMessage({ confirm = () => {}, cancel = () => {}, close = () => {} }) {
  const { $store: store, $i18n } = useNuxtApp()

  const messageOption = computed(() => ({
    header: '',
    message: $i18n.t('double_booking_remind_dialog'),
    customConfirmBtnText: $i18n.t('double_booking_keep_button'),
    customCloseBtnText: $i18n.t('double_booking_check_button'),
    showCancelBtn: true,
    confirm,
    cancel,
    close,
  }))

  function showMessageModal() {
    store.dispatch('dialog/setRootMessageOption', { status: true, options: messageOption.value })
  }

  return {
    showMessageModal,
  }
}

export function useOrderCompletedMessage({ confirm = () => {}, cancel = () => {}, close = () => {} }) {
  const { $store: store, $i18n } = useNuxtApp()

  const messageOption = computed(() => ({
    header: $i18n.t('booking_complete_title'),
    message: $i18n.t('booking_success_email_sms'),
    customConfirmBtnText: $i18n.t('double_booking_check_button'),
    confirm,
    cancel,
    close,
  }))

  function showMessageModal() {
    store.dispatch('dialog/setRootMessageOption', { status: true, options: messageOption.value })
  }

  return {
    showMessageModal,
  }
}

export function useSoldOutMessage({ confirm = () => {}, cancel = () => {}, close = () => {} }) {
  const { $store: store, $i18n } = useNuxtApp()

  const messageOption = computed(() => ({
    header: $i18n.t('all_sold_out'),
    message: $i18n.t('sold_out_msg'),
    confirm,
    cancel,
    close,
  }))

  function showMessageModal() {
    store.dispatch('dialog/setRootMessageOption', { status: true, options: messageOption.value })
  }

  return {
    showMessageModal,
  }
}

export function useErrorMessage({ confirm = () => {}, cancel = () => {}, close = () => {} }) {
  const { $store: store, $i18n } = useNuxtApp()

  const messageOption = computed(() => ({
    header: $i18n.t('message_title_error'),
    confirm,
    cancel,
    close,
  }))

  function showMessageModal(message = '') {
    if (!message) {
      return
    }
    store.dispatch('dialog/setRootMessageOption', { status: true, options: { ...messageOption.value, message } })
  }

  return {
    showMessageModal,
  }
}

export function useBaseMessage({ data = toRefs({}), confirm = () => {}, cancel = () => {}, close = () => {} }) {
  const { $store: store } = useNuxtApp()
  const textPayload = computed(() => ({
    header: data.header?.value || '',
    message: data.message?.value || '',
    customConfirmBtnText: data.customConfirmBtnText?.value || '',
    customCloseBtnText: data.customCloseBtnText?.value || '',
    showCancelBtn: data.showCancelBtn?.value || false,
    useCloseIcon: data.useCloseIcon?.value || false,
  }))

  const messageOption = computed(() => ({
    ...textPayload.value,
    confirm,
    cancel,
    close,
  }))

  function showMessageModal() {
    store.dispatch('dialog/setRootMessageOption', { status: true, options: messageOption.value })
  }

  return {
    showMessageModal,
  }
}
